export type StoreNames =
    | "KIWI"
    | "MENY"
    | "Coop Extra"
    | "Extra"
    | "Coop Prix"
    | "Coop Mega"
    | "Europris"
    | "Joker"
    | "REMA 1000"
    | "Obs"
    | "SPAR"
    | "Bunnpris";

type NoColour = "noColour";

interface ButtonProps {
    label: string;
    colour?: StoreNames | NoColour;
    selected?: boolean;
    dimUnselected?: boolean;
    disabled?: boolean;
    outline?: boolean;
    onClick?: (event: any) => void;
}

const KIWI_COLOURS = {
    base: "bg-[rgb(108,182,87)] text-black hover:bg-[rgb(90,150,70)]",
    selected: "bg-[rgb(90,150,70)] text-white",
};
const MENY_COLOURS = {
    base: "bg-[rgb(183,43,53)] text-white hover:bg-[rgb(150,30,40)]",
    selected: "bg-[rgb(150,30,40)] text-white",
};
const COOP_EXTRA_COLOURS = {
    base: "bg-[rgb(216,54,35)] text-white hover:bg-[rgb(180,40,30)]",
    selected: "bg-[rgb(180,40,30)] text-white",
};
const COOP_PRIX_COLOURS = {
    base: "bg-[rgb(234,203,72)] text-black hover:bg-[rgb(220,190,60)]",
    selected: "bg-[rgb(220,190,60)] text-black",
};
const COOP_MEGA_COLOURS = {
    base: "bg-[rgb(55,84,42)] text-white hover:bg-[rgb(45,70,30)]",
    selected: "bg-[rgb(45,70,30)] text-white",
};
const EUROPRIS_COLOURS = {
    base: "bg-[rgb(44,103,68)] text-white hover:bg-[rgb(30,80,50)]",
    selected: "bg-[rgb(30,80,50)] text-white",
};
const JOKER_COLOURS = {
    base: "bg-[rgb(61,139,92)] text-white hover:bg-[rgb(40,110,70)]",
    selected: "bg-[rgb(40,110,70)] text-white",
};
const REMA_COLOURS = {
    base: "bg-[rgb(24,61,159)] text-white hover:bg-[rgb(20,50,130)]",
    selected: "bg-[rgb(20,50,130)] text-white",
};
const OBS_COLOURS = {
    base: "bg-[rgb(18,50,98)] text-white hover:bg-[rgb(15,40,80)]",
    selected: "bg-[rgb(15,40,80)] text-white",
};
const BUNNPRIS_COLOURS = {
    base: "bg-[rgb(251,235,91)] text-black hover:bg-[rgb(240,220,70)]",
    selected: "bg-[rgb(240,220,70)] text-black",
};
const SPAR_COLOURS = {
    base: "bg-[rgb(207,46,38)] border-[rgb(207,46,38)] text-white hover:bg-[rgb(170,35,30)]",
    selected: "bg-[rgb(170,35,30)] text-white",
};

export const baseColourClasses: { [key in StoreNames | NoColour]: string } = {
    KIWI: KIWI_COLOURS.base,
    MENY: MENY_COLOURS.base,
    "Coop Extra": COOP_EXTRA_COLOURS.base,
    Extra: COOP_EXTRA_COLOURS.base,
    "Coop Prix": COOP_PRIX_COLOURS.base,
    "Coop Mega": COOP_MEGA_COLOURS.base,
    Europris: EUROPRIS_COLOURS.base,
    Joker: JOKER_COLOURS.base,
    "REMA 1000": REMA_COLOURS.base,
    Obs: OBS_COLOURS.base,
    Bunnpris: BUNNPRIS_COLOURS.base,
    SPAR: SPAR_COLOURS.base,
    noColour: "",
};

export const selectedColourClasses: { [key in StoreNames | NoColour]: string } =
    {
        KIWI: KIWI_COLOURS.selected,
        MENY: MENY_COLOURS.selected,
        "Coop Extra": COOP_EXTRA_COLOURS.selected,
        Extra: COOP_EXTRA_COLOURS.selected,
        "Coop Prix": COOP_PRIX_COLOURS.selected,
        "Coop Mega": COOP_MEGA_COLOURS.selected,
        Europris: EUROPRIS_COLOURS.selected,
        Joker: JOKER_COLOURS.selected,
        "REMA 1000": REMA_COLOURS.selected,
        Obs: OBS_COLOURS.selected,
        Bunnpris: BUNNPRIS_COLOURS.selected,
        SPAR: SPAR_COLOURS.selected,
        noColour: "bg-gray-300",
    };

export const Button = ({
    label,
    colour = "noColour",
    selected,
    disabled,
    outline,
    onClick,
    dimUnselected,
}: ButtonProps) => {
    let colorClass = selected
        ? selectedColourClasses[colour]
        : baseColourClasses[colour];

    if (dimUnselected && !selected) {
        colorClass += " opacity-30";
    }

    return (
        <button
            disabled={disabled}
            onClick={onClick}
            className={`
        inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium
        ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring 
        focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 
        [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-10 px-4 py-2 flex-1 sm:flex-none
        ${colorClass}
        ${outline ? "border border-black" : ""}
      `}
        >
            {label}
        </button>
    );
};
